
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { CsvImporterComponent } from "../csvImporter/csvImporter.component";
import { RoutePlanningComponent } from "./routePlanner/routePlanner.component";

export class PlanningConfig {

    static $inject = ["$stateProvider"];

    constructor($stateProvider: StateProvider) {
    }
}

angular
    .module("app.components.tms", [
        "ui.router",
        "app.components.util.api"
    ])
    .config(PlanningConfig)
    .component("csvImporter", new CsvImporterComponent())
    .component("routePlanner", new RoutePlanningComponent())
    ;
